import React from 'react'
import asofixLogo from '../../../images/logo-dark.svg'

export default function HeroBanner() {
  return (
    <div className="inicio-hero">
      <img className="inicio-hero__logo" src={asofixLogo} alt="Asofix" />
      <p className="inicio-hero__title">
        Toda tu gestión comercial,{' '}
        <b>en un solo lugar</b>
      </p>
      <span className="inicio-hero__rule" />
      <p className="inicio-hero__description">
        Estamos preparando tu espacio de trabajo. Desde aquí podrás ver tus
        métricas, alertas y las acciones clave para cada día.
      </p>
    </div>
  )
}
